import { ConsentFormTemplate } from '@lmc/common/types'
import { ConsentForm, Resident } from '@lmc/ts-common'

export const getResidentShortCut = (resident: Resident) =>
  `${resident?.name?.first.toUpperCase().charAt(0)}${resident?.name?.last
    .toUpperCase()
    .charAt(0)}`

/**
 * True when the working copy body matches the canonical template body for this id.
 * Uses string equality — the old implementation used `String.prototype.match` with the
 * copy as a regex pattern, which misclassified many HTML bodies (e.g. GP Connect) as edited.
 */
export const isMatchingFormBody = (
  item: { id: string; body?: string },
  templates: ConsentFormTemplate[]
): boolean => {
  const template = templates.find((form) => form.id === item.id)
  if (!template) {
    return true
  }
  const current = typeof item.body === 'string' ? item.body : ''
  const baseline = typeof template.body === 'string' ? template.body : ''
  return current === baseline
}

export const getResidentConsentFormsTemplates = (
  templates: any,
  consentForms: any
) =>
  templates?.filter(
    (template: any) =>
      !consentForms
        ?.filter((form: any) => !form.isArchived)
        .map((form: any) => form.consentTemplate)
        .includes(template.id)
  )

export const customConsentFormsEmpty = (
  consentForms: ConsentForm[],
  sideControlIds: any[]
) =>
  (!sideControlIds?.length ||
    sideControlIds?.every((item) => item.isSelected === false)) &&
  consentForms.every(
    (consentForm) =>
      consentForm.isCustom &&
      consentForm.body === `<p>Custom Form</p>` &&
      consentForm.title === `Custom Title`
  )
